// extracted by mini-css-extract-plugin
export default {"banner":"Showcase_banner__AftOu","image":"Showcase_image__uRx7x","backBtn":"Showcase_backBtn__6X-Bb","nextBtn":"Showcase_nextBtn__vxT3E","App":"Showcase_App__2rMwm"};